import React, { useEffect, useState } from 'react';
import { Container, Form, Spinner, Button, Row, Col, Card} from 'react-bootstrap';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { useNavigate, Link } from 'react-router-dom';

import api from '../../api/api';
import { ShowIfLoggedIn, ShowIfLoggedInAndVerified } from '../auth/auth_utils';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';
import './FundSelector.css';

export default function FundSelector() {
  const [fundHouses, setFundHouses] = useState([]);
  const [selFundHouses, setSelFundHouses] = useState([]);
  const [userFundLimit, setUserFundLimit] = useState(3);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get('/fund-houses'),
      api.get('/getUserFunds'),
    ]).then(([funds, userFundInfo]) => {
      setFundHouses(funds.data);
      // console.log("Funds tracked: ", fundHouses);

      // console.log("User Funds fetched: ", userFunds.data);
      if (userFundInfo.data) {
        console.log("User Fund Info fetched: ", userFundInfo.data);
        setUserFundLimit(userFundInfo.data.userFundLimit);
        if (userFundInfo.data.userFunds.length > 0) {
          setSelFundHouses([]);
          userFundInfo.data.userFunds.forEach(fundObj => setSelFundHouses(prev => [...prev, fundObj.fund_info_id]));
        } else {
          console.log("No funds selected yet by user.");
        }
      }
    }).catch(err => setError('Failed to load funds for selection.')
    ).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner animation="border" className="m-3" />;

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    try {
      const res = await api.post('/setUserFunds', JSON.stringify([...selFundHouses]));
      if (res.status === 200) {
        navigate('/dashboard');
      } else {
        // setShow(true);
        setError(res.data.message || 'Failed to select funds');
      }
      return res.data
    } catch (err) {
      // setShow(true);
      setError(err.response?.data?.message || 'Failed to select funds');
    }
  };

  // Handle the onChange event for each checkbox
  const handleOptionChange = (event) => {
    const { name, value, checked } = event.target;
    // console.log("Checkbox changed: ", event.target);
    console.log("Checkbox checked status: ", checked);
    let clickedVal = name;
    if (typeof name === 'string') {
        clickedVal = parseInt(name);
        console.log("Checkbox click is: ", clickedVal);
    }

    // Create a new Set based on the previous state to maintain immutability
    const newSelectedOptions = new Set(selFundHouses);
    if (newSelectedOptions.has(clickedVal)) {
        console.log(typeof(value), "- Checkbox click is already selected: value is ", value);
        newSelectedOptions.delete(clickedVal); // Remove value if unchecked
    } else if (checked) {
        if (newSelectedOptions.size < userFundLimit) {
            newSelectedOptions.add(clickedVal); // Add value if checked
        } else {
            setShow(true);
            // setError("You can select maximum {userFundLimit} funds only.");
        }
    } else {
        // newSelectedOptions.delete(value); // Remove value if unchecked
        console.log("Checkbox click Ignored: ", clickedVal);
    }
    if (newSelectedOptions.size === 0) {
        setSelFundHouses([]);
    } else {
        setSelFundHouses([...newSelectedOptions]);
    }
    console.log("Selected Funds updated: ", Array.from(newSelectedOptions));
  };

  const fundGridLayout = (fundHouses) => {
    const columns = 3;
    const rows = [];

    // Loop with a step (increment by number of columns)
    for (let i = 0; i < fundHouses.length; i += columns) {
      const rowItems = [];
      // Inner loop to create columns within the row
      for (let j = 0; j < columns; j++) {
        if (i + j < fundHouses.length) {
          rowItems.push(
            <Col key={i + j} md={4}>
              <Card className="mb-3">
                <Card.Body>
                    <Form.Check
                        name={fundHouses[i + j].fund_info_id}
                        type="checkbox"
                        label={fundHouses[i + j].fund_name}
                        id={`checkbox-${fundHouses[i + j].fund_info_id}`}
                        value={fundHouses[i + j].created_at}
                        onChange={handleOptionChange}
                        checked={selFundHouses.includes(fundHouses[i + j].fund_info_id)}
                        className="ms-2 custom-checkbox"
                    />
                </Card.Body>
              </Card>
            </Col>
          );
        }
      }
      rows.push(<Row key={i}>{rowItems}</Row>);
    }
    return <Container>{rows}</Container>;
  };
  // italic btn-sm fw-bold

  return (
    <div className="bg-light p-3">
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <>
           <ShowIfLoggedInAndVerified>
                 <div className="multi-select-container" style={{background: '#f8f9fa', height: '90%', overflow: 'auto'}}>
                    {error && <p className="text-danger">{error}</p>}
                    <Form className="p-1" onSubmit={handleSubmit}>
                      <Row className="d-flex align-items-center mb-2">
                        <Col xs={3}>
                            <Button className="ms-2 btn-primary fw-bold" type="submit" >
                            {loading ? 'Loading Funds...' : 'Submit Selected Funds'}
                          </Button>
                        </Col>
                        <Col xs={6} className="text-center">
                            <h5 className="text-muted">Select max. {userFundLimit} funds of your choice (selected - {selFundHouses.length}) </h5>
                        </Col>
                        <Col xs={3} className="text-end">
                            <Button as={Link} to="/dashboard" className="btn-alternate-path align-right">
                            {loading ? 'Loading Funds...' : 'Go back to Tracked Schemes'}
                          </Button>
                        </Col>
                      </Row>
                      {fundGridLayout(fundHouses)}
                    </Form>
                    <ToastContainer position="top-end" className="p-3">
                        <Toast onClose={() => setShow(false)} show={show} delay={5000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">Notification</strong>
                            <small>Fund Selection</small>
                        </Toast.Header>
                        <Toast.Body>You can select maximum {userFundLimit} funds only, not deleting earlier selection in last 24 hours.</Toast.Body>
                        </Toast>
                    </ToastContainer>
                </div>
            </ShowIfLoggedInAndVerified>
          </>
        )}
    </div>
  );
}

